<template>
    <div class="flex flex-row items-center gap-1 w-full min-w-0">
        <!-- MYAC-918 — « ‹ » back to the person's conversations, and the one the
             dock holds, named (the mockup, PR 868). -->
        <span v-if="hasBack" v-tooltip.bottom="t('conversations.back_to_list')" class="inline-flex shrink-0">
            <!-- In the brand colour (MYAC-1269): a grey chevron was easy to miss. -->
            <Button icon="pi pi-chevron-left" text size="small" :aria-label="t('conversations.back_to_list')"
                data-testid="chat-panel-back" @click="emit('back')" />
        </span>
        <span v-if="title" class="flex-1 min-w-0 truncate pl-1" :class="sectionTitle ? 'section-title' : 'text-sm font-medium text-surface-900'" :title="title"
            data-testid="chat-panel-title">{{ title }}</span>
        <div v-else class="flex-1" />
        <span v-if="hasExpand" v-tooltip.left="t('chat.panel-expand')" class="inline-flex shrink-0">
            <Button icon="pi pi-window-maximize" text size="small" :aria-label="t('chat.panel-expand')"
                @click="emit('expand')" />
        </span>
        <span v-tooltip.left="t('chat.panel-close')" class="inline-flex shrink-0">
            <Button icon="pi pi-times" text size="small" :aria-label="t('chat.panel-close')"
                @click="emit('close')" />
        </span>
    </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import Button from 'primevue/button'

// MYAC-917 — the docked panel's toolbar row (expand-to-full-page + close);
// MYAC-918 — the way back to the list, and the conversation's title.

withDefaults(defineProps<{
    hasExpand: boolean
    /** « ‹ » to the person's conversations — only while that list exists (the
     *  `enable_conversations` flag). */
    hasBack?: boolean
    /** The conversation the dock holds, by its title. */
    title?: string
    /** The title is a section label (the conversations list), styled like the
     *  Conversation page's column heading (MYAC-1269). */
    sectionTitle?: boolean
}>(), { hasBack: true, title: '', sectionTitle: false })

const emit = defineEmits<{
    back: []
    expand: []
    close: []
}>()

const { t } = useI18n()
</script>

<style scoped>
.section-title { font-size: 12px; font-weight: 600; letter-spacing: 0.07em; text-transform: uppercase; color: var(--p-surface-500); }
</style>
